export const geocodePickupCode = {
  response: {
    success: true,
    data: [
      {
        _id: "65686c79822c8fa75796539a",
        name: "London Heathrow Airport",
        category: "airport",
        lat: "51.469603",
        lng: "-0.453566",
        iata: "LHR",
        cityName: "London",
        cityId: "LON",
        country: "United Kingdom",
      },
      {
        _id: "65686406822c8fa7578f7a9e",
        name: "Heathrow LHR Apartments",
        giataId: "969417",
        category: "hotel",
        lat: "51.48247904",
        lng: "-0.44883744",
        cityName: "London",
        cityId: "302",
        country: "GB",
        address: {
          addressOne: "623 Sipson Road",
          addressTwo: "Hillingdon",
          addressThree: "London UB7 0JE",
          street: "Sipson Road",
          streetNumber: "623",
          cityName: "London",
          postalCode: "UB7 0JE",
        },
      },
      {
        _id: "65685f61822c8fa75789ee23",
        name: "LHR Coliseum B&B",
        giataId: "598403",
        category: "hotel",
        lat: "41.88969697",
        lng: "12.49940972",
        cityName: "Rome",
        cityId: "1175",
        country: "IT",
        address: {
          addressOne: "Via Labicana 92",
          addressTwo: "00184 Rione Monti",
          addressThree: "Roma",
          street: "Via Labicana",
          streetNumber: "92",
          cityName: "Rione Monti",
          postalCode: "00184",
        },
      },
      {
        _id: "65686902822c8fa75795a13d",
        name: "Hotel Nahomi Divisamar By LHR",
        giataId: "1375000",
        category: "hotel",
        lat: "9.40501",
        lng: "-84.1544",
        cityName: "Manuel Antonio",
        cityId: "1314",
        country: "CR",
        address: {
          addressOne: "Carretera A Manuel Antonio Lado Izquierdo",
          addressTwo: "Frente A Restaurante Barba Roja",
          addressThree: "A 5 kms De Quepos Centro",
          street: "Carretera A Manuel Antonio Lado Izquierdo",
          cityName: "Manuel Antonio",
          postalCode: "60601",
        },
      },
    ],
  },
};

export const geocodePickupCodeImplementation = {
  nodejs_Axios: `
  const axios = require('axios');
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=LHR&email=W1user1@email.com',
    headers: { 
      'apikey': 'jlralaOldPgNxckYQ8HlTEqTiqQb7v', 
    }
  };
  
  axios.request(config)
  .then((response) => {
    console.log(JSON.stringify(response.data));
  })
  .catch((error) => {
    console.log(error);
  });
  `,
  python: `
  import requests
  
  url = "https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=LHR&email=W1user1@email.com"
  
  headers = {
    "apikey": "jlralaOldPgNxckYQ8HlTEqTiqQb7v",    
  }
  
  response = requests.get(url, headers=headers)
  
  print(response.json())
  `,
  go: `
  package main
  
  import (
    "fmt"
    "io/ioutil"
    "net/http"
  )
  
  func main() {
    url := "https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=LHR&email=W1user1@email.com"
    req, _ := http.NewRequest("GET", url, nil)
  
    req.Header.Add("apikey", "jlralaOldPgNxckYQ8HlTEqTiqQb7v")
  
    res, _ := http.DefaultClient.Do(req)
  
    defer res.Body.Close()
    body, _ := ioutil.ReadAll(res.Body)
  
    fmt.Println(string(body))
  }
  `,
  curl: `
  curl --location --request GET 'https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=LHR&email=W1user1@email.com' \\
  --header 'apikey: jlralaOldPgNxckYQ8HlTEqTiqQb7v' \\
  `,
  php: `
  <?php
  
  $curl = curl_init();
  
  curl_setopt_array($curl, array(
    CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=LHR&email=W1user1@email.com',
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => '',
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => true,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => 'GET',
    CURLOPT_HTTPHEADER => array(
      'apikey: jlralaOldPgNxckYQ8HlTEqTiqQb7v',      
    ),
  ));
  
  $response = curl_exec($curl);
  
  curl_close($curl);
  echo $response;
  ?>
  `,
};

export const geocodedropCodeOff = {
  response: {
    success: true,
    data: [
      {
        _id: "656857d8822c8fa757822bd9",
        name: "Hilton London Metropole",
        giataId: "27386",
        category: "hotel",
        lat: "51.519360236934",
        lng: "-0.17033904790878",
        cityName: "London",
        cityId: "302",
        country: "GB",
        address: {
          addressOne: "225 Edgware Road",
          addressTwo: "London W2 1JU",
          addressThree: "",
          street: "Edgware Road",
          streetNumber: "225",
          cityName: "London",
          postalCode: "W2 1JU",
        },
      },
      {
        _id: "656857e5822c8fa7578235f2",
        name: "Hilton Brighton Metropole",
        giataId: "30575",
        category: "hotel",
        lat: "50.821566969542",
        lng: "-0.14897257089615",
        cityName: "Brighton and Hove",
        cityId: "88826",
        country: "GB",
        address: {
          addressOne: "Kings Road",
          addressTwo:
            "Situated on the sea-front directly opposite the West pier",
          addressThree: "Brighton",
          street: "Kings Road",
          cityName: "Brighton",
          postalCode: "BN1 2FU",
        },
      },
      {
        _id: "65685814822c8fa757825fc3",
        name: "Hilton Birmingham Metropole",
        giataId: "47103",
        category: "hotel",
        lat: "52.450670926951",
        lng: "-1.7154228687286",
        cityName: "Birmingham",
        cityId: "300",
        country: "GB",
        address: {
          addressOne: "National Exhibition Centre",
          addressTwo: "Birmingham B40 1PP",
          addressThree: "",
          street: "National Exhibition Centre",
          cityName: "Birmingham",
          postalCode: "B40 1PP",
        },
      },
      {
        _id: "65685903822c8fa757832752",
        name: "Hilton Florence Metropole",
        giataId: "111754",
        category: "hotel",
        lat: "43.77349546124",
        lng: "11.189864873886",
        cityName: "Florence",
        cityId: "22507",
        country: "IT",
        address: {
          addressOne: "Via Del Cavallaccio 36",
          addressTwo: "50142 Florence",
          addressThree: "Tuscany",
          street: "Via Del Cavallaccio",
          streetNumber: "36",
          cityName: "Florence",
          postalCode: "50142",
        },
      },
      {
        _id: "65685763822c8fa75781d983",
        name: "Metropole",
        giataId: "1864",
        category: "hotel",
        lat: "35.915982024165",
        lng: "14.499608874321",
        cityName: "Sliema",
        cityId: "479",
        country: "MT",
        address: {
          addressOne: "Sir Adrian Dingli Street",
          addressTwo: "Sliema",
          addressThree: "MALTA",
          street: "Sir Adrian Dingli Street",
          cityName: "Sliema",
        },
      },
    ],
  },
};

export const geocodeDropoffCodeImplementation = {
  nodejs_Axios: `
  const axios = require('axios');
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=Hilton London Metropole&email=W1user1@email.com',
    headers: { 
      'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
    }
  };
  
  axios.request(config)
  .then((response) => {
    console.log(JSON.stringify(response.data));
  })
  .catch((error) => {
    console.log(error);
  });
  `,
  python: `
  import requests
  
  url = "https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=Hilton London Metropole&email=W1user1@email.com"
  
  headers = {
    "apikey": "iL9e30CjZfRok2FuH6KC1xuqCa7C3K"
  }
  
  response = requests.get(url, headers=headers)
  
  print(response.json())
  `,
  go: `
  package main
  
  import (
    "fmt"
    "io/ioutil"
    "net/http"
  )
  
  func main() {
    url := "https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=Hilton London Metropole&email=W1user1@email.com"
    req, _ := http.NewRequest("GET", url, nil)
  
    req.Header.Add("apikey", "iL9e30CjZfRok2FuH6KC1xuqCa7C3K")
  
    res, _ := http.DefaultClient.Do(req)
  
    defer res.Body.Close()
    body, _ := ioutil.ReadAll(res.Body)
  
    fmt.Println(string(body))
  }
  `,
  curl: `
  curl --location --request GET 'https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=Hilton London Metropole&email=W1user1@email.com' \\
  --header 'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
  `,
  php: `
  <?php
  
  $curl = curl_init();
  
  curl_setopt_array($curl, array(
    CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/apisearchPlacesByName?placeName=Hilton London Metropole&email=W1user1@email.com',
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => '',
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => true,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => 'GET',
    CURLOPT_HTTPHEADER => array(
      'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
    ),
  ));
  
  $response = curl_exec($curl);
  
  curl_close($curl);
  echo $response;
  ?>
  `,
};
